/**
 * storyItemSqlApi: the SQL behind one chart (`GET /api/v2/stories/:storyId/items/:itemId/sql`).
 * New-path charts only; any other item answers 409. The text is returned as the server wrote it:
 * never logged, never made up (a missing endpoint is an error the caller words, not a sample).
 */
import { API_ENDPOINTS, apiService } from "../api";
import { mapStoryItemSql } from "./storyItemSqlMappers";
import type { StoryItemSql, StoryItemSqlResponseApi } from "./storyItemSql.types";

export async function fetchStoryItemSql(storyId: string, itemId: string): Promise<StoryItemSql> {
  const body = await apiService.get<StoryItemSqlResponseApi>(API_ENDPOINTS.stories.itemSql(storyId, itemId));
  return mapStoryItemSql(body);
}
